import React from 'react';
import Box from 'core/ui/Box';
import Typography, { fontStyle } from 'core/ui/Typography';
import { primary, redColor, warningColor } from 'core/ui/Colors';
import { Link } from '@material-ui/core';
import { auditedModels } from '.';

const colors = { create: primary, update: warningColor, destroy: redColor };
const removeColumns = ['tokens', 'uid'];

const AuditedChanges = ({ log, setModal }) => (
  <Box>
    <Typography style={{ color: colors[log?.action] }}>{log?.action.toUpperCase()}</Typography>

    {(log.action === 'create' || log.action === 'destroy') && (
      <>
        {Object.keys(log?.auditedChanges)
          .filter((x) => !!log?.auditedChanges[x])
          .filter((x) => !removeColumns.find((y) => y === x))
          .map((itemColumn, idx) => {
            const item = log?.auditedChanges[itemColumn];

            const auditedModel = auditedModels.find(
              (x) => `${x.toUpperCase()}ID` === itemColumn.toUpperCase(),
            );

            return (
              <Box key={idx.toString()} display="flex" alignItems="center">
                <Typography noWrap style={fontStyle.xSmall} className="roboto-regular">
                  {itemColumn?.toUpperCase()}:&nbsp;
                </Typography>
                {auditedModel ? (
                  <Link
                    className="hover"
                    onClick={() =>
                      setModal({ open: true, auditableId: item, auditableType: auditedModel })
                    }
                    style={fontStyle.xSmall}
                  >
                    {JSON.stringify(item)}
                  </Link>
                ) : (
                  <Typography style={fontStyle.xSmall}>{JSON.stringify(item)}</Typography>
                )}
              </Box>
            );
          })}
      </>
    )}
    {log.action === 'update' && (
      <>
        {Object.keys(log?.auditedChanges)
          .filter((x) => !removeColumns.find((y) => y === x))
          .map((itemColumn, idx) => {
            const item = log?.auditedChanges[itemColumn];
            return (
              <Box key={idx.toString()} display="flex" alignItems="center">
                <Typography noWrap style={fontStyle.xSmall} className="roboto-regular">
                  {itemColumn?.toUpperCase()}:&nbsp;
                </Typography>
                <Typography style={{ ...fontStyle.xSmall, color: redColor }}>
                  {JSON.stringify(item[0]) || 'NULL'}
                </Typography>
                &nbsp;|&nbsp;
                <Typography style={{ ...fontStyle.xSmall, color: primary }}>
                  {JSON.stringify(item[1]) || 'NULL'}
                </Typography>
              </Box>
            );
          })}
      </>
    )}
  </Box>
);

export default AuditedChanges;
